import { useState, useEffect } from 'react'
import { getBooks, deleteBook, ApiError } from '../lib/api'
import type { BookSummary } from '../types/models'

export function useBooks() {
  const [books, setBooks] = useState<BookSummary[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  async function load() {
    setLoading(true)
    setError(null)
    try {
      setBooks(await getBooks())
    } catch (e) {
      setError(e instanceof ApiError ? e.message : 'Failed to load books')
    } finally {
      setLoading(false)
    }
  }

  async function removeBook(id: string) {
    try {
      await deleteBook(id)
      await load()
    } catch (e) {
      setError(e instanceof ApiError ? e.message : 'Failed to delete book')
    }
  }

  // setState only in async continuations (react-hooks/set-state-in-effect). `loading` starts true.
  useEffect(() => {
    let cancelled = false
    getBooks()
      .then((b) => { if (!cancelled) setBooks(b) })
      .catch((e) => { if (!cancelled) setError(e instanceof ApiError ? e.message : 'Failed to load books') })
      .finally(() => { if (!cancelled) setLoading(false) })
    return () => { cancelled = true }
  }, [])

  return { books, loading, error, refresh: load, removeBook }
}
